import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApplyJobModal, RecommendJobModal } from '../../components/ApplyJobModal';
import { selectVacancy } from '../../selectors/vacancies';
import { IRetrieveVacancyResponseV2 } from '../../common/repositories/job-vacancies-backend/entities/vacancies/RetrieveVacancyResponseV2';
import { useApply } from './hooks';
import { selectForm } from '../../selectors/form';
import { IInputsState } from '../../types/form';
import { setErrors, setInputsState } from '../../actions/form';
import { UploaderContainer } from '../Uploader';

interface IApplyOrRecommendContainerProps {
  isApplyWindowOpen: boolean;
  isRecommendWindowOpen: boolean;
  onClose: () => void;
}

export const ApplyOrRecommendContainer: React.FC<IApplyOrRecommendContainerProps> = ({
  isApplyWindowOpen,
  isRecommendWindowOpen,
  onClose,
}) => {
  const { onApply, onRecommend } = useApply();
  const dispatch = useDispatch();
  const vacancy = useSelector(selectVacancy) as IRetrieveVacancyResponseV2;
  const form = useSelector(selectForm);

  const onChangeHandler = (inputState: Partial<IInputsState>) => {
    dispatch(setErrors({}));
    dispatch(setInputsState(inputState));
  };

  if (!vacancy) {
    return null;
  }

  return (
    <>
      <ApplyJobModal
        isOpen={isApplyWindowOpen}
        onClose={onClose}
        onSubmit={onApply}
        inputValues={form.inputsState}
        onChange={onChangeHandler}
        vacancy={vacancy}
        isLoading={form.isLoading}
        isFileUploading={form.isFileUploading}
        errors={form.errors}
        isSubmitted={form.isSubmitted}
      >
        <UploaderContainer />
      </ApplyJobModal>

      <RecommendJobModal
        isOpen={isRecommendWindowOpen}
        onClose={onClose}
        onSubmit={onRecommend}
        inputValues={form.inputsState}
        onChange={onChangeHandler}
        vacancy={vacancy}
        isLoading={form.isLoading}
        isFileUploading={form.isFileUploading}
        errors={form.errors}
        isSubmitted={form.isSubmitted}
      >
        <UploaderContainer />
      </RecommendJobModal>
    </>
  );
};
